import {Component} from '@angular/core';
import {ThirdPartyComponent} from '../../../third-party.component';

@Component({
  selector: 'app-adobe-express-info-access',
  standalone: true,
  imports: [
    ThirdPartyComponent
  ],
  templateUrl: './adobe-express-info-access.component.html',
  styleUrl: './adobe-express-info-access.component.scss'
})
export class AdobeExpressInfoAccessComponent {
  readonly vendorName = 'adobe';
  readonly name = 'express';
}
